import { ButtonComponent } from "./components/button/button.component";
import { CardListComponent } from "./components/card-list/card-list.component";
import { CardViewComponent } from "./components/card-view/card-view.component";
import { ChartComponent } from "./components/chart/chart.component";
import { CompanyInfoNoticeComponent } from "./components/company-info-notice/company-info-notice.component";
import { BooleanComponent } from "./components/controls/boolean/boolean.component";
import { CheckboxComponent } from "./components/controls/checkbox/checkbox.component";
import { DateComponent } from "./components/controls/date/date.component";
import { FileComponent } from "./components/controls/file/file.component";
import { MobileNumberComponent } from "./components/controls/mobile-number/mobile-number.component";
import { OptionFieldComponent } from "./components/controls/option-field/option-field.component";
import { SearchableListComponent } from "./components/controls/searchable-list/searchable-list.component";
import { TextFieldComponent } from "./components/controls/text-field/text-field.component";
import { NotesComponent } from "./components/notes/notes.component";
import { NoticeModalComponent } from "./components/notice-modal/notice-modal.component";
import { PagenationComponent } from "./components/pagenation/pagenation.component";
import { ServiceProgressComponent } from "./components/service-progress/service-progress.component";
import { ScreenLoaderComponent } from "./components/screen-loader/screen-loader.component";
import { TableComponent } from "./components/table/table.component";
import { ValidationMessageComponent } from "./components/validation-message/validation-message.component";
import { ConfirmationModalComponent } from "./components/confirmation-modal/confirmation-modal.component";
import { MfaEmailOtpComponent } from "./components/mfa-email-otp/mfa-email-otp.component";
import { VerifyEmailComponent } from "./components/verify-email/verify-email.component";


export const SHARED_COMPONENTS = [
  TextFieldComponent,
  BooleanComponent,
  CheckboxComponent,
  DateComponent,
  FileComponent,
  OptionFieldComponent,
  SearchableListComponent,
  ButtonComponent,
  ServiceProgressComponent,
  ScreenLoaderComponent,
  ValidationMessageComponent,
  MfaEmailOtpComponent,
  VerifyEmailComponent,
  TableComponent,
  MobileNumberComponent,
  PagenationComponent,
  CardListComponent,
  NotesComponent,
  NoticeModalComponent,
  CardViewComponent,
  ConfirmationModalComponent,
  ChartComponent,
  CompanyInfoNoticeComponent
];
